module.exports = __webpack_public_path__ + "static/maps_img-af0617ad37743d410befadfd35809b80.png";